/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaSource model module.
 * @module model/AqaSource
 * @version v0
 */
export default class AqaSource {
  /**
   * Constructs a new <code>AqaSource</code>.
   * @alias module:model/AqaSource
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaSource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaSource} obj Optional instance to populate.
   * @return {module:model/AqaSource} The populated <code>AqaSource</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaSource();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('umbrellaIds'))
        obj.umbrellaIds = ApiClient.convertToType(data['umbrellaIds'], ['String']);
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Number');
      if (data.hasOwnProperty('createdBy'))
        obj.createdBy = ApiClient.convertToType(data['createdBy'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('orientation'))
        obj.orientation = ApiClient.convertToType(data['orientation'], 'String');
      if (data.hasOwnProperty('example'))
        obj.example = ApiClient.convertToType(data['example'], 'Boolean');
      if (data.hasOwnProperty('imported'))
        obj.imported = ApiClient.convertToType(data['imported'], 'Boolean');
      if (data.hasOwnProperty('timestamp'))
        obj.timestamp = ApiClient.convertToType(data['timestamp'], 'Number');
      if (data.hasOwnProperty('originalSourceId'))
        obj.originalSourceId = ApiClient.convertToType(data['originalSourceId'], 'String');
      if (data.hasOwnProperty('originalAccountId'))
        obj.originalAccountId = ApiClient.convertToType(data['originalAccountId'], 'String');
      if (data.hasOwnProperty('originalTimestamp'))
        obj.originalTimestamp = ApiClient.convertToType(data['originalTimestamp'], 'Number');
      if (data.hasOwnProperty('publicationId'))
        obj.publicationId = ApiClient.convertToType(data['publicationId'], 'String');
      if (data.hasOwnProperty('subscribedId'))
        obj.subscribedId = ApiClient.convertToType(data['subscribedId'], 'String');
      if (data.hasOwnProperty('subscribedQdId'))
        obj.subscribedQdId = ApiClient.convertToType(data['subscribedQdId'], 'String');
      if (data.hasOwnProperty('skipEmpties'))
        obj.skipEmpties = ApiClient.convertToType(data['skipEmpties'], 'Boolean');
      if (data.hasOwnProperty('emptyColumns'))
        obj.emptyColumns = ApiClient.convertToType(data['emptyColumns'], ['String']);
      if (data.hasOwnProperty('creadtedById'))
        obj.creadtedById = ApiClient.convertToType(data['creadtedById'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AqaSource.prototype.id = undefined;

/**
 * @member {Array.<String>} umbrellaIds
 */
AqaSource.prototype.umbrellaIds = undefined;

/**
 * @member {Number} dateCreated
 */
AqaSource.prototype.dateCreated = undefined;

/**
 * @member {String} createdBy
 */
AqaSource.prototype.createdBy = undefined;

/**
 * @member {String} name
 */
AqaSource.prototype.name = undefined;

/**
 * @member {String} description
 */
AqaSource.prototype.description = undefined;

/**
 * Allowed values for the <code>orientation</code> property.
 * @enum {String}
 * @readonly
 */
AqaSource.OrientationEnum = {
  /**
   * value: "column"
   * @const
   */
  column: "column",

  /**
   * value: "row"
   * @const
   */
  row: "row"
};
/**
 * @member {module:model/AqaSource.OrientationEnum} orientation
 */
AqaSource.prototype.orientation = undefined;

/**
 * @member {Boolean} example
 */
AqaSource.prototype.example = undefined;

/**
 * @member {Boolean} imported
 */
AqaSource.prototype.imported = undefined;

/**
 * @member {Number} timestamp
 */
AqaSource.prototype.timestamp = undefined;

/**
 * @member {String} originalSourceId
 */
AqaSource.prototype.originalSourceId = undefined;

/**
 * @member {String} originalAccountId
 */
AqaSource.prototype.originalAccountId = undefined;

/**
 * @member {Number} originalTimestamp
 */
AqaSource.prototype.originalTimestamp = undefined;

/**
 * @member {String} publicationId
 */
AqaSource.prototype.publicationId = undefined;

/**
 * @member {String} subscribedId
 */
AqaSource.prototype.subscribedId = undefined;

/**
 * @member {String} subscribedQdId
 */
AqaSource.prototype.subscribedQdId = undefined;

/**
 * @member {Boolean} skipEmpties
 */
AqaSource.prototype.skipEmpties = undefined;

/**
 * @member {Array.<String>} emptyColumns
 */
AqaSource.prototype.emptyColumns = undefined;

/**
 * @member {String} creadtedById
 */
AqaSource.prototype.creadtedById = undefined;

